var e=()=>(navigator==null?void 0:navigator.languages)||[];export{e as navigatorDetector};
